import React from "react";
import Barcode from 'react-barcode';

/**
 * @param {Products_Object} product
 * @param visible
 */
export default ({product, visible = false}) => {

	let maxCharacters = 12;
	let minCharacters = 5;

	let cutBarCodeText = (text)=> {
		return text.substr(0, maxCharacters);
	};
	let cutBarCodeTextExtra = (text)=> {
		return ' ' + text.substr(maxCharacters);
	};
	let getBarCodeWidth = (text) => {
		let smallest = 1.6;
		let largest = 2;
		let range = largest - smallest;
		let charRange = maxCharacters - minCharacters;
		let widthSegmentPerCharacter = range / charRange;
		let charsOverMin = text.length - minCharacters;
		let additionalSize = widthSegmentPerCharacter * charsOverMin;
		let newSize = largest - additionalSize;
		return Math.min(Math.max(newSize, smallest), largest);
	};

	let value = product.upc;
	return (
		<div className="ProductLong" style={{
			textAlign: "center",
			justifyContent: "center",

			...visible ? {
				border: '1px solid black',
				borderRadius: '10px',
				display: 'inline-block'
			} : {
				pageBreakBefore: 'always',

				marginLeft: "1px",
			}
		}}>
			<div style={{borderBottom: '2px solid black', padding: "0 10px 0 10px"}}>
				<div className="serialNumber" style={{marginTop: '20px',fontSize: '20px'}}>
					{product.serial_number}
				</div>
				<div className="barCode">
					<Barcode format={'CODE128A'}
					         value={value}
					         height={25}
					         width={1}
					         displayValue={false}/>
				</div>
				<b>{value}</b><br/>
			</div>

			<div className="notes" style={{padding: "5px 0 5px 0", fontSize: "16px"}}>
				<div style={{marginBottom: '5px'}}>
					{product.importer && `${product.importer} / `}
					{!product.manufacturer_other && product.manufacturers ? product.manufacturers.name : product.manufacturer_other}
				</div>

				<div style={{marginBottom: '5px'}}>{product.model}</div>

				<div style={{marginBottom: '5px'}}>{!product.caliber_other && product.calibers ? product.calibers.name : product.caliber_other}</div>
				{product.sku && <div>{product.sku}</div>}
			</div>
			<div className="pageBreak"/>
		</div>
	);
};
